import { render, staticRenderFns } from "./commonWord.vue?vue&type=template&id=df529c6e&scoped=true&"
import script from "./commonWord.vue?vue&type=script&lang=js&"
export * from "./commonWord.vue?vue&type=script&lang=js&"
import style0 from "./commonWord.vue?vue&type=style&index=0&id=df529c6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df529c6e",
  null
  
)

export default component.exports